import { localisationMaster } from '../Localisation/Localisation'
import { addZero } from './math'
import LocalStorage from '../services/LocalStorage'

const link = 'months'
const months = [
  localisationMaster('months_1', link),
  localisationMaster('months_2', link),
  localisationMaster('months_3', link),
  localisationMaster('months_4', link),
  localisationMaster('months_5', link),
  localisationMaster('months_6', link),
  localisationMaster('months_7', link),
  localisationMaster('months_8', link),
  localisationMaster('months_9', link),
  localisationMaster('months_10', link),
  localisationMaster('months_11', link),
  localisationMaster('months_12', link),
]

export function dateFormat(oDate = new Date(), format = 'dd.mm.YYYY', error) {
  const ud = LocalStorage.get('ud')
  const user_data = ud?.user_data
  const userData = user_data?.profile
  const lang = userData?.localization
  try {
    if (typeof oDate === 'string' || typeof oDate === 'number')
      oDate = new Date(oDate)

    format = format
      .replace('dd', addZero(oDate.getDate()))
      .replace('d', oDate.getDate())
      .replace('mm', addZero(oDate.getMonth() + 1))
      .replace(
        'MMMM',
        lang === 'EN'
          ? months[oDate.getMonth()]
          : months[oDate.getMonth()].toLowerCase(),
      )
      .replace('MMM', months[oDate.getMonth()])
      .replace('YYYY', oDate.getFullYear())
      .replace('YY', String(oDate.getFullYear()).slice(2))

      .replace('hh', addZero(oDate.getHours()))
      .replace('ii', addZero(oDate.getMinutes()))
      .replace('ss', addZero(oDate.getSeconds()))
    return format
  } catch (e) {
    return error ? error : 'Invalid date'
  }
}

export const scheduleDays = (arr) => {
  const days = [
    localisationMaster('text_22', 'groups/all-groups'),
    localisationMaster('text_23', 'groups/all-groups'),
    localisationMaster('text_24', 'groups/all-groups'),
    localisationMaster('text_25', 'groups/all-groups'),
    localisationMaster('text_26', 'groups/all-groups'),
    localisationMaster('text_27', 'groups/all-groups'),
    localisationMaster('text_28', 'groups/all-groups'),
  ]

  return arr.map((wd) => days[--wd]).join('/')
}

export const formatDate = (dateString) => {
  const date = new Date(dateString)

  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0') // Месяцы в JavaScript начинаются с 0
  const year = date.getFullYear()
  const hours = date.getHours().toString().padStart(2, '0')
  const minutes = date.getMinutes().toString().padStart(2, '0')

  return `${day}.${month}.${year} ${hours}:${minutes}`
}
